import React, { Component } from 'react'
import FixedSlideNav from '../../../components/navbar/FixedSlideNav'
import PropTypes from 'prop-types'
import DtoJobTable from '../../dto/DtoJobTable'
import ProgressCard from '../../../components/card/ProgressCard'
import i18n from 'simple-react-i18n'
import { getExecStatusLabel, getExecStatusIcon, getJobListNewTable } from '../../../utils/JobUtils'
import { connect } from 'react-redux'
import { push } from '@lagunovsky/redux-react-router'
import JobAction from '../../actions/JobAction'
import SieauAction from '../../../components/sieau/SieauAction'
import JobTableExecutionsForm from './JobTableExecutionsForm'
import { getFullDate } from '../../../utils/DateUtil'
import { getUser } from '../../../utils/SettingUtils'
import { groupBy, omit } from 'lodash'
import { setActions } from '../../../components/ActionUtil'
import AppStore from '../../../store/AppStore'
import ContributorDto from '../../../referencial/components/contributor/dto/ContributorDto'
import WaitAction from 'wait/WaitAction'
import { Accordion, AccordionDetails, AccordionSummary, Button, Card, CardContent, Dialog, DialogActions, DialogContent, Grid, Stack, Tooltip } from '@mui/material'
import DtoUserBookmark from '../../../administration/components/user/dto/DtoUserBookmark'
import UserAction from '../../../administration/components/user/actions/UserAction'
import { filterAllCharacters } from '../../../utils/StringUtil'
import { STATION_TYPE_CONSTANT } from '../../../station/constants/StationConstants'
import AddTraitementsStepper from 'traitements/components/AddTreatementsStepper'
import HomeAction from 'home/actions/HomeAction'
import CityAction from 'referencial/components/city/actions/CityAction'
import { CardTable, NewTable } from '../../../components/datatable/NewTable'
import { darkBlue } from '../../../utils/constants/ColorTheme'
import { Box } from '@mui/material'
import cronstrue from 'cronstrue/i18n'
import { getCurrentLang } from 'utils/LangUtils'
import moment from 'moment'
import { DefaultDialogTitle } from 'components/styled/Dialog'
import { IMPORT } from 'traitements/constants/TraitementConstants'

const HEADERS = ['jobId', 'jobExecutionId', 'jobType', 'jobName', 'status', 'date', 'user', 'administrator', 'programmation', 'nullValue', 'nullValue2', 'nullValue3']
const CHAIN_HEADERS = ['nameOfTheChain', 'expectedResult', 'status', 'lastExecution', 'chain']


const BOOK_M = 'bookM'
const CHAINED = 'chained'
const CRON = 'cron'
const MANUAL = 'manual'
const DRAFT = 'draft'
const ALREADY_START = 8
const JOB_ERROR = 0
const JOB_STOPPED = 3
const JOB_WARNING = 2
const JOB_NOT_EXECUTED = 8

class JobTableExecutions extends Component {
    constructor(props) {
        super(props)
        this.state = AppStore.getState().JobReducer.jobTableCache || {
            progress: 0,
            filters: {
                searchValue: undefined,
                startDate: null,
                scheduled: undefined,
                status: [],
                endDate: null,
                file: undefined,
                station: undefined,
                displayMode: 'job',
                jobType: undefined,
            },
            sort: {
                column: 'date',
                sort: 'desc',
            },
            dataLoaded: false,
            openAddStationPopup: false,
            openChainPopup: false,
            openAccordions: [],
            chain: [],
            allJobs: [],
            initialType: '',
            initialAction: '',
            autoOpenAddStation: false,
        }
        this.state.dataLoaded = false
        this.state.openAddStationPopup = false
        this.state.openChainPopup = false
    }


    componentDidMount() {
        const hasToOpen = this.props.location.state?.hasToOpen || false
        if (hasToOpen) {
            if (hasToOpen) {
                this.setState({ openAddStationPopup: true, autoOpenAddStation: true, initialType: this.props.location.state?.initialType, initialAction: IMPORT })
            }
        }
        this.props.setTitle([
            {
                title: i18n.jobs,
                href: 'job',
            },
        ])
        this.props.fetchBookmarks()
        this.props.fetchCities()
        this.props.fetchJobTable(omit(this.state.filters, ['searchValue'])).then(() => {
            this.setComponentActions()
            this.setState({ dataLoaded: true })
        })
    }


    componentDidUpdate(prevProps, prevState) {
        this.setComponentActions()
        const { filters } = this.state
        const { jobs, contributorsIndex } = this.props

        const dataChanged =prevProps.jobs !== jobs || prevProps.userBookmarks !== this.props.userBookmarks || prevState.filters !== filters

        if (dataChanged) {
            const data = getJobListNewTable(jobs, contributorsIndex)

            const filteredData = filterAllCharacters(
                data.jobs,
                ['jobType', 'jobName', 'jobExecutionId'],
                filters.searchValue,
            )

            const grouped = groupBy(
                data.jobs,
                j =>j.job.jobNextId || j.job.jobPreviousId? CHAINED: (j.job.cron ? CRON : (j.job.status === ALREADY_START ? DRAFT : MANUAL)),
            )

            const chaines = this.construireChaines(grouped)

            const filteredChains = !filters.searchValue
                ? chaines
                : chaines.filter(chain =>
                    chain.some(job =>
                        filterAllCharacters(
                            [{
                                jobType: job.jobType,
                                jobName: job.jobName,
                                jobExecutionId: job.jobExecutionId,
                            }],
                            ['jobType', 'jobName', 'jobExecutionId'],
                            filters.searchValue,
                        ).length > 0,
                    ),
                )

            const chainedIds = filteredChains.reduce((ids, chain) => {
                return {
                    ...ids,
                    ...Object.fromEntries(chain.map(job => [job.jobId, true])),
                }
            }, {})

            const groupedFiltered = {
                chained: filteredData.filter(j => chainedIds[j.job.jobId]),
                cron: filteredData.filter(j => !chainedIds[j.job.jobId] && j.job.cron),
                manual: filteredData.filter(j => !chainedIds[j.job.jobId] && !j.job.cron && j.job.status !== ALREADY_START),
                draft: filteredData.filter(j => !chainedIds[j.job.jobId] && j.job.status === ALREADY_START),
            }
            const userBookmarksFilter = this.props.userBookmarks.filter(ub => ub.stationType === STATION_TYPE_CONSTANT.JOB)

            const bookmarkIds = userBookmarksFilter
                .map(b => parseInt(b.identifiant))
                .reduce((acc, id) => (acc.includes(id) ? acc : [...acc, id]), [])
            const filteredBookMarkJobs = filteredData.filter(job =>bookmarkIds.includes(job.id))
            const defaultOpen = this.getDefaultOpen(filteredBookMarkJobs, groupedFiltered)
            this.setState({ openAccordions: defaultOpen ? [defaultOpen] : [] })
        }
    }

    handleToggle = (key) => {
        this.setState(prevState => {
            const isOpen = prevState.openAccordions.includes(key)
            return {
                openAccordions: isOpen
                    ? prevState.openAccordions.filter(k => k !== key)
                    : [...prevState.openAccordions, key],
            }
        })
    }

    getDefaultOpen(filteredBookMarkJobs, grouped) {
        if (filteredBookMarkJobs?.length > 0) return BOOK_M
        if (grouped.chained?.length > 0) return CHAINED
        if (grouped.cron?.length > 0) return CRON
        if (grouped.manual?.length > 0) return MANUAL
        if (grouped.draft?.length > 0) return DRAFT
        return null
    }

    onChangeSort(column, sort) {
        this.setState({ sort: { column, sort } }, () => AppStore.dispatch(JobAction.setJobCache(this.state)))
    }


    setComponentActions() {
        if (this.state.dataLoaded) {
            const newJob = (() => {
                const user = getUser()
                if (user.consultant !== '1' && user.isAdmin === '1') {
                    return {
                        new: () => this.setState({ openAddStationPopup: true, autoOpenAddStation: false, initialType: '', initialAction: '' }),
                    }
                }
                return null
            })()
            const action = {
                ...newJob,
                export: () => {
                    const data = this.getExportData()
                    return {
                        data,
                        exportType: 'xlsx',
                        titleFile: i18n.jobs,
                    }
                },
            }
            setActions(action)
        }
    }
    getExportData() {
        const headers = ['jobId', 'jobType', 'jobExecutionId', 'jobName', 'statusCode', 'statusLabel', 'date', 'user', 'scheduled']
        const tableData = this.props.jobs.map(job => {
            return {
                statusCode: { value: job.status, format: '0', cellType: 'number' },
                statusLabel: getExecStatusLabel(job).replace('\n', ' '),
                date: { value: getFullDate(job.date), format: 'dd/MM/yyyy HH:mm:ss', cellType: 'date' },
                scheduled: job.cron ? i18n.yes : i18n.no,
                user: job.login,
                jobId: { value: job.jobId, format: '0', cellType: 'number' },
                jobExecutionId: { value: job.jobExecutionId, format: '0', cellType: 'number' },
                jobName: job.jobName,
                jobType: job.jobType,
            }
        })
        tableData[0].headers = headers
        return tableData
    }

    fetchJobTable(filters, forceLoad = false) {
        this.props.waitStart()

        const requestFilters = omit({
            ...filters,
            station: filters.station || undefined,
            forceLoad,
            scheduled: filters.scheduled && (
                filters.scheduled === 1 ||
            !(filters.scheduled === 2)
            ),
        }, ['searchValue'])

        this.props.fetchJobTable(requestFilters)
            .then(() => {
                const filteredJobs = this.props.jobs

                return this.props.fetchJobTable(
                    omit({
                        ...requestFilters,
                        status: [],
                    }, ['status']),
                )
                    .then(() => {
                        const allJobs = this.props.jobs

                        this.setState({
                            filters,
                            dataLoaded: true,
                            allJobs,
                        }, () => {
                            this.props.fetchJobTable(requestFilters)

                            AppStore.dispatch(JobAction.setJobCache(this.state))
                        })
                    })
                    .catch(() => {
                        this.setState({
                            filters,
                            dataLoaded: true,
                            allJobs: filteredJobs,
                        })
                    })
            })
            .finally(() => this.props.waitStop())
    }

    getSortStatus(status) {
        const statusCodes = {
            done: 1,
            done_warning: 2,
            hourglass_full: 3,
            local_cafe: 4,
            more_horiz: 5,
            error: 6,
            hide_source: 7,
            cloud_off: 8,
        }

        return {
            ...status,
            sortValue: typeof status.value.props.children === 'object' ? statusCodes.done_warning : statusCodes[status.value.props.children] ?? 7,
        }
    }

    construireChaines = grouped => {
        const jobs = (grouped.chained ?? []).map(item => item.job)

        const jobsById = jobs.reduce((acc, job) => ({ ...acc, [job.jobId]: job }), {})

        const construireChaine = (job, chain = [], visited = {}) => {
            if (!job || visited[job.jobId]) {
                return chain
            }

            return construireChaine(jobsById[job.jobNextId], [...chain, job], { ...visited, [job.jobId]: true })
        }

        return jobs.filter(job => !jobsById[job.jobPreviousId]).map(job => construireChaine(job))
    }

    getTable() {
        const data = getJobListNewTable(this.props.jobs, this.props.contributorsIndex)

        const chainData = getJobListNewTable(this.state.allJobs.length? this.state.allJobs: this.props.jobs, this.props.contributorsIndex)

        if (this.state.filters.displayMode === 'job') {
            const filteredData = filterAllCharacters(data.jobs, ['jobType', 'jobName', 'jobExecutionId'], this.state.filters.searchValue)

            const grouped = groupBy(chainData.jobs, j =>j.job.jobNextId || j.job.jobPreviousId? CHAINED: (j.job.cron? CRON: (j.job.status === ALREADY_START ? DRAFT : MANUAL)))

            const allChains = this.construireChaines(grouped)

            const filteredChains = allChains.filter(chain => {
                const matchSearch =!this.state.filters.searchValue ||chain.some(job =>
                    filterAllCharacters(
                        [{
                            jobType: job.jobType,
                            jobName: job.jobName,
                            jobExecutionId: job.jobExecutionId,
                        }],
                        ['jobType', 'jobName', 'jobExecutionId'], this.state.filters.searchValue,
                    ).length > 0,
                )

                const matchStatus =!this.state.filters.status?.length ||chain.some(job =>this.state.filters.status.includes(job.status))

                return matchSearch && matchStatus
            })

            const chainedIds = filteredChains.reduce((ids, chain) => {
                return {
                    ...ids,
                    ...Object.fromEntries(chain.map(job => [job.jobId, true])),
                }
            }, {})

            const groupedFiltered = {
                chained: filteredData.filter(j => chainedIds[j.job.jobId]),
                cron: filteredData.filter(j => !chainedIds[j.job.jobId] && j.job.cron),
                manual: filteredData.filter(j => !chainedIds[j.job.jobId] && !j.job.cron && j.job.status !== ALREADY_START),
                draft: filteredData.filter(j => !chainedIds[j.job.jobId] && j.job.status === ALREADY_START),
            }

            const userBookmarksFilter = this.props.userBookmarks.filter(ub => ub.stationType === STATION_TYPE_CONSTANT.JOB)

            const bookmarkIds = userBookmarksFilter.map(b => parseInt(b.identifiant)).reduce((acc, id) => (acc.includes(id) ? acc : [...acc, id]), [])

            const filteredBookMarkJobs = filteredData.filter(job =>bookmarkIds.includes(job.id))

            const getChainStatus = (jobs) => {
                if (jobs.some(job => job.status === JOB_ERROR)) {
                    return jobs.find(job => job.status === JOB_ERROR)
                }

                if (jobs.some(job => job.status === JOB_STOPPED)) {
                    return jobs.find(job => job.status === JOB_STOPPED)
                }

                if (jobs.some(job => job.status === JOB_WARNING)) {
                    return jobs.find(job => job.status === JOB_WARNING)
                }
                return jobs[0]
            }


            const rows = filteredChains.map(jobs => {
                const firstJob = jobs[0]
                const chainStatusTable = getJobListNewTable([getChainStatus(jobs)], this.props.contributorsIndex).jobs[0]
                const lastExecution = jobs.reduce((latest, job) => {
                    return !latest || moment(job.date).isAfter(latest)? job.date: latest
                }, null)
                return {
                    nameOfTheChain: firstJob?.jobName ?? '',
                    chain: {
                        value: (
                            <Stack direction='row' spacing={1}>
                                {jobs.map((job, index) => {
                                    const hasPreviousError = jobs.slice(0, index).some(previousJob => previousJob.status === 0)
                                    const execution = hasPreviousError ? { status: JOB_NOT_EXECUTED } : job
                                    return (
                                        <Box
                                            key={job.jobId}
                                            onClick={() => this.props.push(`/import/${job.jobId}`)}
                                            sx={{ cursor: 'pointer' }}
                                        >
                                            {getExecStatusIcon(execution, 20, job.jobName)}
                                        </Box>
                                    )
                                })}
                            </Stack>
                        ),
                    },
                    expectedResult: firstJob.cron ? (() => {
                        try {
                            return cronstrue.toString(firstJob.cron, { locale: getCurrentLang()[0] })
                        } catch (e) {
                            return ''
                        }
                    })() : '',
                    status: this.getSortStatus(chainStatusTable.status),
                    lastExecution: lastExecution ? getFullDate(lastExecution) : '',
                    jobs,
                }
            })

            return (
                <Stack spacing={1} sx={{ width: '100%' }}>
                    {
                        !!(filteredBookMarkJobs || []).length && (
                            <Accordion
                                expanded={this.state.openAccordions.includes(BOOK_M)}
                                onChange={() => this.handleToggle(BOOK_M)}
                            >
                                <AccordionSummary color={darkBlue}>
                                    {i18n.favoriteProcessing} ({filteredBookMarkJobs.length} {i18n.elements})
                                </AccordionSummary>
                                <AccordionDetails sx={{ padding: 0 }}>
                                    <NewTable
                                        rows={filteredBookMarkJobs}
                                        headers={HEADERS}
                                        onClickRow={r => this.props.push(`/import/${r.id}`)}
                                        headersLabel={{
                                            jobExecutionId: i18n.execution,
                                        }}
                                    />
                                </AccordionDetails>
                            </Accordion>
                        )}
                    {
                        !!(groupedFiltered.chained || []).length && (
                            <Accordion
                                expanded={this.state.openAccordions.includes(CHAINED)}
                                onChange={() => this.handleToggle(CHAINED)}
                            >
                                <AccordionSummary color={darkBlue}>
                                    {i18n.chainedProcessing} ({filteredChains.length} {i18n.elements})
                                </AccordionSummary>
                                <AccordionDetails sx={{ padding: 0 }}>
                                    <NewTable
                                        rows={rows}
                                        headers={CHAIN_HEADERS}
                                        onClickRow={r => {
                                            this.setState({
                                                openChainPopup: true,
                                                chain: getJobListNewTable(r.jobs, this.props.contributorsIndex).jobs,
                                            })
                                        }}
                                    />
                                </AccordionDetails>
                            </Accordion>
                        )
                    }
                    {
                        !!(groupedFiltered.cron || []).length && (
                            <Accordion
                                expanded={this.state.openAccordions.includes(CRON)}
                                onChange={() => this.handleToggle(CRON)}
                            >
                                <AccordionSummary color={darkBlue}>
                                    {i18n.scheduledProcessing} ({(groupedFiltered.cron?.map(c => {
                                        return {
                                            ...c,
                                            status: this.getSortStatus(c.status),
                                        }
                                    }) || []).length} {i18n.elements})
                                </AccordionSummary>
                                <AccordionDetails sx={{ padding: 0 }}>
                                    <NewTable
                                        rows={groupedFiltered.cron?.map(c => {
                                            return {
                                                ...c,
                                                status: this.getSortStatus(c.status),
                                            }
                                        }) || []}
                                        headers={HEADERS}
                                        onClickRow={r => this.props.push(`/import/${r.id}`)}
                                        headersLabel={{
                                            jobExecutionId: i18n.execution,
                                        }}
                                    />
                                </AccordionDetails>
                            </Accordion>
                        )}
                    {
                        !!(groupedFiltered.manual || []).length && (
                            <Accordion
                                expanded={this.state.openAccordions.includes(MANUAL)}
                                onChange={() => this.handleToggle(MANUAL)}
                            >
                                <AccordionSummary color={darkBlue}>
                                    {i18n.manualProcessing} ({(groupedFiltered.manual?.map(c => {
                                        return {
                                            ...c,
                                            status: this.getSortStatus(c.status),
                                        }
                                    }) || []).length} {i18n.elements})
                                </AccordionSummary>
                                <AccordionDetails sx={{ padding: 0 }}>
                                    <NewTable
                                        rows={groupedFiltered.manual?.map(c => {
                                            return {
                                                ...c,
                                                status: this.getSortStatus(c.status),
                                            }
                                        }) || ''}
                                        headers={HEADERS}
                                        onClickRow={r => this.props.push(`/import/${r.id}`)}
                                        headersLabel={{
                                            jobExecutionId: i18n.execution,
                                        }}
                                    />
                                </AccordionDetails>
                            </Accordion>
                        )}
                    {
                        !!(groupedFiltered.draft || []).length && (
                            <Accordion
                                expanded={this.state.openAccordions.includes(DRAFT)}
                                onChange={() => this.handleToggle(DRAFT)}
                            >
                                <AccordionSummary color={darkBlue}>
                                    {i18n.draftProcessing} ({(groupedFiltered.draft?.map(c => {
                                        return {
                                            ...c,
                                            status: this.getSortStatus(c.status),
                                        }
                                    }) || []).length} {i18n.elements})
                                </AccordionSummary>
                                <AccordionDetails sx={{ padding: 0 }}>
                                    <NewTable
                                        rows={groupedFiltered.draft?.map(c => {
                                            return {
                                                ...c,
                                                status: this.getSortStatus(c.status),
                                            }
                                        }) || []}
                                        headers={HEADERS}
                                        onClickRow={r => this.props.push(`/import/${r.id}`)}
                                        headersLabel={{
                                            jobExecutionId: i18n.execution,
                                        }}
                                    />
                                </AccordionDetails>
                            </Accordion>
                        )}
                    <AddTraitementsStepper
                        isOpen={this.state.openAddStationPopup}
                        setIsOpen={() => this.setState({ openAddStationPopup: false })}
                        initialStep={this.state.autoOpenAddStation ? 2 : 0}
                        initialAction={this.state.autoOpenAddStation ? this.state.initialAction : ''}
                        initialType={this.state.autoOpenAddStation ? this.state.initialType : ''}
                    />
                    <Dialog
                        fullWidth
                        maxWidth='xl'
                        open={this.state.openChainPopup}
                    >
                        <DefaultDialogTitle title={i18n.chainedProcessing} onClose={() => this.setState({ openChainPopup: false })} />
                        <DialogContent>
                            <NewTable
                                rows={this.state.chain?.map(c => ({
                                    ...c,
                                    status: this.getSortStatus(c.status),
                                    jobName: {
                                        ...c.jobName,
                                        value: (
                                            <Tooltip title={c.jobName.value}>
                                                {c.jobName.value.length > 20
                                                    ? `${c.jobName.value.substring(0, 20)}...`
                                                    : c.jobName.value}
                                            </Tooltip>
                                        ),
                                    },
                                })) || []}
                                headers={HEADERS}
                                onClickRow={(r) => this.props.push(`/import/${r.job.jobId}`)}
                                headersLabel={{
                                    jobExecutionId: i18n.execution,
                                }}
                            />
                        </DialogContent>
                        <DialogActions>
                            <Button
                                onClick={() => this.setState({ openChainPopup: false })}
                                variant='outlined'
                            >
                                {i18n.cancel}
                            </Button>
                        </DialogActions>
                    </Dialog>
                </Stack>

            )
        }

        return (
            <Stack sx={{ width: '100%' }}>
                <CardTable
                    color={darkBlue}
                    title={`${i18n.execution} (${data.jobs.length} ${i18n.displayedElementsOn} ${this.props.count})`}
                    rows={data.jobs?.map(c => {
                        return {
                            ...c,
                            status: this.getSortStatus(c.status),
                        }
                    })}
                    headers={HEADERS}
                    onClickRow={r => this.props.push(`/import/${r.id}`)}
                    headersLabel={{
                        jobExecutionId: i18n.execution,
                    }}
                    hideNbElements

                />
            </Stack>
        )
    }


    render() {
        const { dataLoaded } = this.state
        const navLinks = [
            {
                href: '/job/list',
                name: i18n.jobs,
                icons: 'cached',
                'data-cy': 'nav-import',
            },
            {
                href: '/job/ftp',
                name: i18n.ftpTree,
                icons: 'folder_zip',
                'data-cy': 'nav-ftp',
            },
        ]

        return (
            <Box>
                <FixedSlideNav links={navLinks} />
                <Box className='content-page padding-1 fullscreen'>
                    {dataLoaded ? (
                        <Grid container spacing={1}>
                            <Card>
                                <CardContent>
                                    <JobTableExecutionsForm
                                        onSubmit={(filters) => this.fetchJobTable(filters)}
                                        contributors={this.props.contributors}
                                    />
                                </CardContent>
                            </Card>
                            {this.getTable()}
                        </Grid>
                    ) : (
                        <Grid><ProgressCard progress={this.state.progress} /></Grid>
                    )}
                </Box>
            </Box>
        )
    }
}

JobTableExecutions.propTypes = {
    jobs: PropTypes.arrayOf(PropTypes.instanceOf(DtoJobTable)),
    count: PropTypes.number,
    fetchJobTable: PropTypes.func,
    contributorsIndex: PropTypes.objectOf(PropTypes.instanceOf(ContributorDto)),
    contributors: PropTypes.arrayOf(PropTypes.instanceOf(ContributorDto)),
    userBookmarks: PropTypes.arrayOf(PropTypes.shape({})),
    push: PropTypes.func,
    waitStart: PropTypes.func,
    waitStop: PropTypes.func,
    setTitle: PropTypes.func,
    fetchCities: PropTypes.func,
    fetchBookmarks: PropTypes.func,
    userbookmarks: PropTypes.arrayOf(PropTypes.instanceOf(DtoUserBookmark)),
    location: PropTypes.shape({ state: PropTypes.shape({ hasToOpen: PropTypes.bool, initialType: PropTypes.string }) }),
}

const mapStateToProps = store => ({
    jobs: store.JobReducer.jobTable.data,
    count: store.JobReducer.jobTable.count,
    contributorsIndex: store.ContributorReducer.contributorsIndex,
    contributors: store.ContributorReducer.contributors,
    userBookmarks: store.UserReducer.userBookmarks,
})

const mapDispatchToProps = {
    fetchJobTable: JobAction.fetchJobTable,
    forceFetch: SieauAction.forceFetch,
    waitStart: WaitAction.waitStart,
    waitStop: WaitAction.waitStop,
    fetchBookmarks: UserAction.fetchBookmarks,
    fetchCities: CityAction.fetchCities,
    setTitle: HomeAction.setTitle,
    push,
}

export default connect(mapStateToProps, mapDispatchToProps)(JobTableExecutions)